<template>
  <div>
    <div class="font-semibold mb-1">{{ event.event_name }}</div>
    <div class="flex flex-wrap gap-x-2 text-muted-foreground">
      <div class="flex gap-1">
        <span>{{ event.tournament_name }}</span>
        <span>{{ event.season }}</span>
      </div>
      <div class="flex gap-1">
        <span>{{ ticket.category_name }}</span>
        -
        <span>{{ formatDays(event.date_start, event.date_stop) }}</span>
      </div>
      <div class="flex gap-1">
        <span>{{ formatDates(event.date_start, event.date_stop) }}</span>
      </div>
      <div class="flex gap-1">
        <span>{{ event.venue_name }}</span>
        <span>{{ event.city }}</span>
      </div>
    </div>
  </div>
</template>
<script setup>
import { formatDays } from "@/helpers/format.js";
import { formatDates } from "@xs2event/js-lib";

defineProps({
  event: { required: true },
  ticket: { required: true },
});
</script>
